/* eslint-disable react/jsx-no-constructed-context-values */
/*
 * Title: Reconcile Raw Data - ContextAPI
 * Description: State management for raw data reconciliation
 */

import { createContext, useContext, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import ToastifyService from '../../../services/ToastifyService';
import UrlService from '../../../services/UrlService';

const ContextAPI = createContext();

export function useReconcileRawData() {
    return useContext(ContextAPI);
}

export function ReconcileRawDataProvider({ children }) {
    const [results, setResults] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const [filterType, setFilterType] = useState('all');

    const axiosPrivate = useAxiosPrivate();

    const runReconcile = async (mode) => {
        setLoading(true);
        setResults(null);
        setShowResults(false);
        try {
            const response = await axiosPrivate.post(
                UrlService.reconcileRawDataUrl(),
                JSON.stringify({ mode }),
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );

            if (response?.data?.status === 'success') {
                setResults(response.data);
                setShowResults(true);
                if (mode === 'execute') {
                    ToastifyService.saveNotify('Reconciliation executed successfully!');
                } else {
                    ToastifyService.successNotify('Preview generated. Review changes below.');
                }
            } else {
                ToastifyService.errorNotify(response?.data?.message || 'Reconciliation failed');
            }
        } catch (err) {
            if (!err?.response) {
                ToastifyService.errorNotify('Server Not Responding!');
            } else if (err.response?.status === 401) {
                ToastifyService.errorNotify('Unauthorized!');
            } else {
                ToastifyService.errorNotify(err.response?.data?.message || 'Reconciliation Failed!');
            }
        } finally {
            setLoading(false);
        }
    };

    const clearResults = () => {
        setResults(null);
        setShowResults(false);
        setFilterType('all');
    };

    const filteredItems = results?.items?.filter((item) => {
        if (filterType === 'all') return true;
        return item.type === filterType;
    }) || [];

    return (
        <ContextAPI.Provider
            value={{
                results,
                loading,
                showResults,
                setShowResults,
                filterType,
                setFilterType,
                filteredItems,
                runReconcile,
                clearResults,
            }}
        >
            {children}
        </ContextAPI.Provider>
    );
}

export default ContextAPI;
